import { render, staticRenderFns } from "./bargainAct.vue?vue&type=template&id=b3c5605e&scoped=true&"
import script from "./bargainAct.vue?vue&type=script&lang=js&"
export * from "./bargainAct.vue?vue&type=script&lang=js&"
import style0 from "./bargainAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./bargainAct.vue?vue&type=style&index=1&id=b3c5605e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c5605e",
  null
  
)

component.options.__file = "bargainAct.vue"
export default component.exports